import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16, IcoSearch16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import { Command } from 'cmdk';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '../../../icon-button';
type CommandInputProps = {
  value?: string;
  onValueChange?: (value: string) => void;
  onErase?: () => void;
  size?: 'compact' | 'default';
  placeholder?: string;
  border?: 'all' | 'bottom';
  autoFocus?: boolean;
};
const CommandInput = t0 => {
  const $ = _c(27);
  const {
    value,
    onValueChange,
    onErase,
    size: t1,
    placeholder,
    border: t2,
    autoFocus: t3
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const border = t2 === undefined ? "bottom" : t2;
  const autoFocus = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      keyPrefix: "components.command"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const {
    t
  } = useTranslation("ui", t4);
  const inputRef = useRef(null);
  let t5;
  let t6;
  if ($[1] !== autoFocus) {
    t5 = () => {
      if (inputRef.current && autoFocus) {
        inputRef.current.focus();
      }
    };
    t6 = [autoFocus];
    $[1] = autoFocus;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  useEffect(t5, t6);
  let t7;
  if ($[4] !== onErase || $[5] !== onValueChange) {
    t7 = () => {
      if (onErase) {
        onErase();
      } else {
        onValueChange?.("");
      }
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };
    $[4] = onErase;
    $[5] = onValueChange;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const handleErase = t7;
  const t8 = border === "bottom";
  const t9 = border === "all";
  const t10 = border === "all";
  let t11;
  if ($[7] !== t10 || $[8] !== t8 || $[9] !== t9) {
    t11 = cx("flex items-center justify-center gap-2 px-2 py-1.5 border-solid border-tertiary h-[44px]", {
      "border-b": t8,
      border: t9,
      rounded: t10
    });
    $[7] = t10;
    $[8] = t8;
    $[9] = t9;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <IcoSearch16 color="tertiary" />;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== size) {
    t13 = cx("flex-1 text-body-2 text-primary placeholder:text-tertiary focus-visible:outline-none", {
      "min-h-[26px]": size === "compact"
    }, {
      "min-h-[28px]": size === "default"
    });
    $[12] = size;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== onValueChange || $[15] !== placeholder || $[16] !== t13 || $[17] !== value) {
    t14 = <Command.Input ref={inputRef} value={value} onValueChange={onValueChange} placeholder={placeholder} className={t13} />;
    $[14] = onValueChange;
    $[15] = placeholder;
    $[16] = t13;
    $[17] = value;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== handleErase || $[20] !== t || $[21] !== value) {
    t15 = value && <IconButton aria-label={t("erase-search")} onClick={handleErase} size="compact" icon={IcoCloseSmall16} />;
    $[19] = handleErase;
    $[20] = t;
    $[21] = value;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t11 || $[24] !== t14 || $[25] !== t15) {
    t16 = <div className={t11}>{t12}{t14}{t15}</div>;
    $[23] = t11;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
};
export default CommandInput;